<div class="d-flex h-100 flex-column justify-content-center align-items-center">
  <div class="display-1">404</div>
  <div>The page does not exist.</div>
</div>
